import { useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../../features/auth'
import { useCreateUser } from '../../entities/user'
import { UserFormWidget, UserFormValues, prepareTechnicianProfileForApi } from '../../features/user-management'
import { routes } from '../../shared/config/routes'
import PageLayout from '../../shared/ui/layouts/PageLayout/PageLayout'
import { Modal } from '../../shared/ui'

export function UserCreatePage() {
  const navigate = useNavigate()
  const user = useAuthStore((s) => s.user)
  const createUser = useCreateUser()
  const submitRef = useRef<(() => void) | null>(null)
  const [createdPassword, setCreatedPassword] = useState<string | null>(null)

  if (!user?.roles?.length) return null

  const handleSubmit = async (data: UserFormValues) => {
    const prepared = prepareTechnicianProfileForApi(data) as any
    if (!prepared.password) delete prepared.password
    await createUser.mutateAsync(prepared)
    if (data.password) {
      setCreatedPassword(data.password)
    } else {
      navigate(routes.users.root)
    }
  }

  const handlePasswordModalClose = () => {
    setCreatedPassword(null)
    navigate(routes.users.root)
  }

  return (
    <>
      <PageLayout
        pageTitle="Neuer Benutzer"
        scrollable
        back
        backTo={routes.users.root}
        primaryAction={{
          label: 'Speichern',
          onClick: () => submitRef.current?.(),
          loading: createUser.isPending,
        }}
      >
        <div className="flex flex-row gap-[60px] mt-6">
          <UserFormWidget
            mode="create"
            actorRoles={user.roles}
            onSubmit={handleSubmit}
            isLoading={createUser.isPending}
            submitRef={submitRef}
          />
        </div>
      </PageLayout>

      <Modal
        show={createdPassword !== null}
        setShow={(open) => { if (!open) handlePasswordModalClose() }}
        title="Benutzer erstellt"
        onClose={handlePasswordModalClose}
        submitButton={{
          title: 'Schließen',
          onSubmit: handlePasswordModalClose,
        }}
      >
        <div className="flex flex-col gap-4 px-2">
          <p className="text-sm text-gray-600">
            Bitte notieren Sie das Passwort — es wird nur einmal angezeigt.
          </p>
          <div className="flex items-center gap-3">
            <code className="flex-1 rounded bg-gray-100 px-4 py-3 font-mono text-base tracking-wide break-all">
              {createdPassword}
            </code>
            <button
              type="button"
              onClick={() => navigator.clipboard.writeText(createdPassword ?? '')}
              className="shrink-0 rounded border border-[#004494] px-3 py-2 text-sm font-medium text-[#004494] hover:bg-blue-50 transition-colors"
            >
              Kopieren
            </button>
          </div>
        </div>
      </Modal>
    </>
  )
}
